import { AnimatePresence, motion } from "framer-motion";
import { codeIcon as CodeIcon, ventureExtras } from "./ventureContent";

export const VentureDetail = ({ venture }) => {
  const extras = venture && ventureExtras[venture.slug];
  return <AnimatePresence mode="wait">
    {extras && <motion.div key={venture.slug} className="venture-detail" initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: .35 }} data-testid={`venture-detail-${venture.slug}`}>
      <div className="venture-detail-head"><p className="eyebrow">{venture.number} / {venture.name}</p><p className="venture-identity" data-testid="venture-identity">{extras.identity}</p></div>
      <div className="venture-detail-grid">
        {extras.list && <div>
          <span className="detail-label">{extras.listTitle}</span>
          <ul className="detail-chips" data-testid="venture-detail-list">{extras.list.map((item) => <li key={item}><CodeIcon size={12} strokeWidth={1.75} aria-hidden="true" />{item}</li>)}</ul>
        </div>}
        <div>
          <span className="detail-label">{extras.noteTitle}</span>
          <p className="detail-note" data-testid="venture-detail-note">{extras.note}</p>
        </div>
      </div>
    </motion.div>}
  </AnimatePresence>;
};
